export default "__VITE_ASSET__lsdLdhEZ__"